<script>
import AppNavbar from '@/components/AppNavbar'
import ArticleCover from '@/components/ArticleCover'
import ArticleMore from '@/components/ArticleMore'
import shareMixin from '@/mixins/shares'

export default {
	name: 'Article2',
	components: {
		AppNavbar,
		ArticleCover,
		ArticleMore,
	},
	mixins: [shareMixin],
	head: {
		title: {
			inner: 'Что делать, если вас укусили?'
		},
		meta: [
			{p: 'og:title', c: 'Афиша Zombie: что делать, если вас укусили?'},
			{p: 'og:description', c: 'Советы для тех, кто хочет жить без ноги в мире "Ходячих мертвецов".' },
			{p: 'og:image', c: '/static/share/2.jpg'},
			{p: 'og:site_name', c: 'Афиша Zombie'},
		]
	},
}
</script>



<template>
<div class="article">
	<app-navbar />
	<article-cover video="articles/2/cover">
		<h2 slot="title">Что делать, если вас укусили?</h2>
		<p slot="text">Советы для тех, кто хочет жить без ноги.</p>
	</article-cover>

	<section class="text start">
		<div class="inner">

			<h2>Если вас укусил ходячий мертвец, то это еще не повод, рыдая, убегать подальше в лес. Вовремя сделанная ампутация спасет вам жизнь. И не только она. Вот несколько простых советов, которые помогут в случае, если ваша жизнь висит на волоске.</h2>

			<h2>Но для начала изучим, что делать, чтобы вас не укусили</h2>

			<p>
				Надеть жесткую защиту, которую не сможет прокусить зомби. Например, воины Хиллтопа используют в качестве доспехов форму для американского футбола. Подойдет также хоккейная защита. Не забудьте про шлем.
			</p>

			<img class="article-image" src="../assets/articles/2/1.jpg">

			<p>
				Есть рабочий способ, чтобы зомби перестали вас замечать и воспринимать как добычу. Для этого вам просто нужно самому притвориться ходячим мертвецом: завуалировать свой запах, полностью обмазавшись кровью и останками мертвяков.
			</p>

			<img class="article-image" src="../assets/articles/2/2.jpg">

			<p>
				Если вам потребуется зомби в качестве раба, сувенира или чучела, то, чтобы обезопасить себя от укуса, следует отрубить ходячему нижнюю челюсть. Так зомби не сможет произвести укус, но останется в рабочем состоянии. Так, например, поступила Мишонн, которая водила за собой на цепи двух зомби без рук и челюстей.
			</p>

			<img class="article-image" src="../assets/articles/2/3.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h2>Что делать, если вас все-таки укусили</h2>

			<p>
				Очень важно, куда пришелся укус. Если в конечности, то вас сможет спасти быстрая ампутация, пока зомби-инфекция не начала распространяться, убивая вас изнутри. Если же укус пришелся в шею, лицо или живот, то выбора у вас уже нет. До свидания!
			</p>

			<img class="article-image" src="../assets/articles/2/4.jpg">

			<p>
				Удаление зараженной части тела нужно произвести незамедлительно. Например, мгновенная операция спасла жизнь старику Хершелу, которому отрезали ногу ниже колена сразу же после укуса. Тогда, кстати, впервые в мире выяснилось, что заражение действительно можно остановить таким способом.
			</p>

			<img class="article-image" src="../assets/articles/2/5.jpg">

			<p>
				Важно, чтобы под рукой были необходимые медикаменты и опытный человек, способный остановить кровотечение. Однажды главные герои пытались спасти Тайриза от заражения при помощи ампутации, но из-за отсутствия нужных условий тот все равно скончался от кровопотери.
			</p>

			<img class="article-image" src="../assets/articles/2/6.jpg">

			<p>
				Некоторые герои вроде Ти-Дога или Тайриза после укуса, осознавая, что скоро они станут ходячими мертвецами, предпочитали героический самоубийственный поступок во благо других выживших. Так что — дерзайте!
			</p>

			<img class="article-image" src="../assets/articles/2/7.jpg">

			<p>
				В конце концов, используйте свои последние часы или минуты на то, на что не хватало времени при жизни. Например, если в вашем убежище есть <a href="https://moscow.rt.ru/inttv" target="_blank" onclick="ga('send', 'event', 'link', 'Esli-vas-ucusili', 'rostelekom')">Интерактивное ТВ Ростелеком</a>, то вы просто счастливчик, и сможете посмотреть начиная с 23 октября премьеру восьмого сезона «Ходячих мертвецов».
			</p>

		</div>
	</section>

	<section class="text footer">
		<div class="inner">
			Смотреть сериал можно в «Интерактивном ТВ Ростелеком».
			<br>
			Если нашествие зомби застало вас не дома, подключайте опцию «Мультискрин» —<br>с ней весь контент будет доступен не только на экране телевизора,<br>но и <a href="https://moscow.rt.ru/inttv" target="_blank" onclick="ga('send', 'event', 'link', 'article', 'rostelekom')">на сайте itv.rt.ru</a> или на вашем мобильном устройстве.
		</div>
	</section>

	<div class="footer-share clearfix">
		<div class="title">Поделиться статьей</div>
		<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
		<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
		<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
		<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
		<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
	</div>

	<div class="devider"></div>

	<section class="text more">
		<div class="inner">Читайте также</div>
	</section>

	<article-more :ids="[6, 2, 3]" />


</div>
</template>



<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article {
	background: #fff;
}

section {
	width: 96%;
	max-width: 1040px;
	margin: 0 auto;
}

section .inner {
	max-width: 740px;
}

section h2 {
	padding: 0;
	margin: 0;
	font-weight: normal;
	font-size: 20px;
	padding-bottom: 20px;
	line-height: 30px;
}

section h3 {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: bold;
	line-height: 27px;
}

section p {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: normal;
	line-height: 27px;
}

.start {
	padding-top: 40px;
}

.text {
	background: #fff;
}

.text a {
	color: @red;
}

.article-image {
	width: 100%;
	max-width: 740px;
	padding: 40px 0;
}

.footer {
	padding: 40px 0;
	font-weight: 400;
	font-style: italic;
	font-family: @fontLava;
	line-height: 27px;
	font-size: 18px;

	a {
		color: @red;
	}
}

.footer-share {
	width: 100%;
	max-width: 1040px;
	margin: 0 auto;

	.title {
		width: 260px;
		height: 60px;
		line-height: 60px;
		font-size: 13px;
		letter-spacing: 1.5px;
		text-align: center;
		text-transform: uppercase;
		color: #fff;
		background: @red;
		float: left;
	}

	a {
		width: 80px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

	a:last-child {
		border-right: none;
	}

	a:hover {
		background: @red;
	}

}

.devider {
	width: 100%;
	height: 5px;
	background: #090909;
	margin-top: 60px;
}

.more {
	color: @red;
	font-size: 30px;
	height: 80px;
	line-height: 80px;
}





@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.footer-share {

	.title {
		display: none;
	}

	a {
		width: 20vw;
		height: 20vw;
		text-align: center;
		line-height: 20vw;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

}

.devider {
	display: none;
}



}

</style>



// WEBPACK FOOTER //
// Article2.vue?f896f320